
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hlCkz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $fHyH9 = parcelRequire("fHyH9");

var $5z48q = parcelRequire("5z48q");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $08369c7a2ef35639$var$i18n = (0, $cgtv4.defineMessages)({
    createWithRovoModalCloseFeedbackFlagTitle: {
        id: "smart-create.create-with-rovo-modal-close-feedback-flag.title",
        defaultMessage: "Help us improve Create with Rovo"
    },
    createWithRovoModalCloseFeedbackFlagDescription: {
        id: "smart-create.create-with-rovo-modal-close-feedback-flag.description",
        defaultMessage: "We'd love your feedback. This quick survey should take less than a minute."
    },
    createWithRovoModalCloseFeedbackFlagSurveyButton: {
        id: "smart-create.create-with-rovo-modal-close-feedback-flag.survey-button",
        defaultMessage: "Share feedback"
    },
    createWithRovoUpdateCompleteFeedbackFlagTitle: {
        id: "smart-create.create-with-rovo-update-complete-feedback-flag.title",
        defaultMessage: "Help us improve Rovo"
    },
    createWithRovoUpdateCompleteFeedbackFlagDescription: {
        id: "smart-create.create-with-rovo-update-complete-feedback-flag.description",
        defaultMessage: "We'd love your feedback. This quick survey should take less than a minute."
    },
    createWithRovoUpdateCompleteFeedbackFlagSurveyButton: {
        id: "smart-create.create-with-rovo-update-complete-feedback-flag.survey-button",
        defaultMessage: "Share feedback"
    }
});
// This is needed because useDialogs expects an onCloseComplete callback, but SmartCreateFeedback does not have one.
const $08369c7a2ef35639$var$SmartCreateFeedbackDialog = ({ onClose: onClose, onCloseComplete: onCloseComplete, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fHyH9.SmartCreateFeedback), {
        onClose: ()=>{
            onClose();
            onCloseComplete();
        },
        ...props
    });
};
const $08369c7a2ef35639$export$f70bd417302214e1 = $08369c7a2ef35639$var$SmartCreateFeedbackDialog;
var $08369c7a2ef35639$export$3f98ccc336fde004 = /*#__PURE__*/ function(FeedbackVariant) {
    FeedbackVariant["AFTER_AIFC_MODAL_CLOSE"] = "after-aifc-modal-close";
    FeedbackVariant["AFTER_UPDATE_STREAM_COMPLETE"] = "after-update-stream-complete";
    return FeedbackVariant;
}({});
const $08369c7a2ef35639$var$getFeedbackConfig = (feedbackVariant, contentType)=>{
    switch(feedbackVariant){
        case "after-aifc-modal-close":
            return {
                flagId: 'create-with-rovo-modal-close-feedback-flag',
                localStorageKey: (0, $1UApO.keys).CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN,
                titleI18n: $08369c7a2ef35639$var$i18n.createWithRovoModalCloseFeedbackFlagTitle,
                descriptionI18n: $08369c7a2ef35639$var$i18n.createWithRovoModalCloseFeedbackFlagDescription,
                feedbackButtonI18n: $08369c7a2ef35639$var$i18n.createWithRovoModalCloseFeedbackFlagSurveyButton,
                cooldownMs: 2592000000,
                // 30 days
                flagDisplayProbability: 1.0,
                extraDialogProps: {
                    variant: (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO,
                    additionalFields: {
                        'Entry Point': 'Confluence after AIFC modal close flag',
                        contentType: contentType
                    }
                }
            };
        case "after-update-stream-complete":
            return {
                flagId: 'create-with-rovo-update-complete-feedback-flag',
                localStorageKey: (0, $1UApO.keys).CREATE_WITH_ROVO_UPDATE_COMPLETE_FEEDBACK_FLAG_LAST_SHOWN,
                titleI18n: $08369c7a2ef35639$var$i18n.createWithRovoUpdateCompleteFeedbackFlagTitle,
                descriptionI18n: $08369c7a2ef35639$var$i18n.createWithRovoUpdateCompleteFeedbackFlagDescription,
                feedbackButtonI18n: $08369c7a2ef35639$var$i18n.createWithRovoUpdateCompleteFeedbackFlagSurveyButton,
                cooldownMs: 7776000000,
                // 90 days
                flagDisplayProbability: 0.15,
                extraDialogProps: {
                    variant: (0, $5z48q.SmartCreateFeedbackVariant).ROVO,
                    additionalFields: {
                        'Entry Point': 'Confluence after update streaming complete flag',
                        contentType: contentType
                    }
                }
            };
    }
};
const $08369c7a2ef35639$export$1a045593947945d = (flags, intl, showModal, feedbackVariant, contentType, createAnalyticsEvent)=>{
    const config = $08369c7a2ef35639$var$getFeedbackConfig(feedbackVariant, contentType);
    if (!$08369c7a2ef35639$var$isInCooldownPeriod(config.localStorageKey, config.cooldownMs) && $08369c7a2ef35639$export$fbdb6f5075225f8e(config.flagDisplayProbability)) {
        createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: 'smartCreateFeedbackFlag',
                attributes: {
                    feedbackVariant: feedbackVariant,
                    contentType: contentType
                }
            }
        }).fire();
        flags.showFlag({
            id: config.flagId,
            title: intl.formatMessage(config.titleI18n),
            description: intl.formatMessage(config.descriptionI18n),
            type: 'success',
            onClose: ()=>{
                createAnalyticsEvent?.({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'smartCreateFeedbackClose',
                        source: 'smartCreateFeedbackFlag',
                        attributes: {
                            feedbackVariant: feedbackVariant,
                            contentType: contentType
                        }
                    }
                }).fire();
            },
            actions: [
                {
                    content: intl.formatMessage(config.feedbackButtonI18n),
                    onClick: ()=>{
                        createAnalyticsEvent?.({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'smartCreateFeedbackShare',
                                source: 'smartCreateFeedbackFlag',
                                attributes: {
                                    feedbackVariant: feedbackVariant,
                                    contentType: contentType
                                }
                            }
                        }).fire();
                        flags.hideFlag(config.flagId);
                        showModal($08369c7a2ef35639$var$SmartCreateFeedbackDialog, {
                            onClose: ()=>{},
                            onSubmit: ()=>{},
                            ...config.extraDialogProps
                        });
                    }
                }
            ]
        });
        (0, $17wUi.confluenceLocalStorageInstance).setItem(config.localStorageKey, Date.now().toString());
    }
};
const $08369c7a2ef35639$var$isInCooldownPeriod = (localStorageKey, cooldownMs)=>{
    try {
        const lastShown = (0, $17wUi.confluenceLocalStorageInstance).getItem(localStorageKey);
        if (!lastShown) return false;
        return Date.now() - parseInt(lastShown) < cooldownMs;
    } catch (error) {
        return false;
    }
};
const $08369c7a2ef35639$export$fbdb6f5075225f8e = (probability)=>{
    return Math.random() < probability;
};
module.exports["FeedbackVariant"] = $08369c7a2ef35639$export$3f98ccc336fde004;
module.exports["showCreateWithRovoModalCloseFeedbackFlag"] = $08369c7a2ef35639$export$1a045593947945d;

});

parcelRegister("fHyH9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $biiXa = parcelRequire("biiXa");


var $1uunn = parcelRequire("1uunn");


var $8qaEU = parcelRequire("8qaEU");


var $6tcD9 = parcelRequire("6tcD9");


var $l3BrO = parcelRequire("l3BrO");


var $5z48q = parcelRequire("5z48q");

const $67831e29f8762387$var$ANALYTICS_CHANNEL = 'aiMate';
const $67831e29f8762387$var$ENTRYPOINT_ID = '63867aef-06e5-4520-855f-4d29e062f22c';
const $67831e29f8762387$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $67831e29f8762387$var$constructFeedbackContext = (additionalFields, aaid)=>{
    const userAgent = navigator.userAgent;
    const screenResolution = `${window.screen.width} x ${window.screen.height}`;
    const feedbackContext = {
        'User-Agent': userAgent,
        'Screen Resolution': screenResolution,
        'User Account Id': aaid ?? 'unknown',
        /* Other context fields will have to be passed in as props, since there aren't public hooks to get these.
    Environment: metadata.environment ?? '',
    'Cloud Id': metadata.cloudId ?? '',
    Product: metadata.product ?? '',
    Edition: metadata.edition ?? '',
    */ ...additionalFields
    };
    const feedbackContextStr = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${value}`).join('\n');
    return [
        {
            id: $67831e29f8762387$var$FEEDBACK_CONTEXT_FIELD_ID,
            value: feedbackContextStr
        }
    ];
};
const $67831e29f8762387$var$getFeedbackConfig = (variant)=>{
    switch(variant){
        case (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO:
            return {
                feedbackTitle: (0, $l3BrO.messages).feedbackTitle,
                rateExperience: (0, $l3BrO.messages).rateExperience
            };
        case (0, $5z48q.SmartCreateFeedbackVariant).ROVO:
            return {
                feedbackTitle: (0, $l3BrO.messages).feedbackTitleNoCreate,
                rateExperience: (0, $l3BrO.messages).rateExperienceNoCreate
            };
    }
};
function $67831e29f8762387$export$35c06614b8d216da(props) {
    const { name: name, aaid: aaid, email: email } = (0, $1uunn.useProfileController)();
    return /*#__PURE__*/ (0, $l998X.jsx)($67831e29f8762387$export$4a210f0e33a62fe0, {
        name: name,
        aaid: aaid,
        email: email,
        ...props
    });
}
function $67831e29f8762387$export$4a210f0e33a62fe0({ variant: variant = (0, $5z48q.SmartCreateFeedbackVariant).CREATE_WITH_ROVO, onClose: onClose, onSubmit: onSubmit, additionalFields: additionalFields = {}, name: name, aaid: aaid, email: email }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { feedbackTitle: feedbackTitle, rateExperience: rateExperience } = $67831e29f8762387$var$getFeedbackConfig(variant);
    const categories = (0, $42omo.useMemo)(()=>[
            {
                id: 'performance',
                text: formatMessage((0, $l3BrO.messages).categoryPerformance)
            },
            {
                id: 'response-quality',
                text: formatMessage((0, $l3BrO.messages).categoryResponseQuality)
            },
            {
                id: 'user-experience',
                text: formatMessage((0, $l3BrO.messages).categoryUserExperience)
            },
            {
                id: 'other',
                text: formatMessage((0, $l3BrO.messages).categoryOther)
            }
        ], [
        formatMessage
    ]);
    const [experienceRating, setExperienceRating] = (0, $42omo.useState)(undefined);
    const [selectedCategory, setSelectedCategory] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
    }, [
        variant,
        createAnalyticsEvent
    ]);
    const onCloseWithAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'closed',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
        onClose();
    }, [
        onClose,
        variant,
        createAnalyticsEvent
    ]);
    const onSubmitWithAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'submitted',
            actionSubject: 'smartCreateFeedbackCollector',
            attributes: {
                feedbackVariant: variant,
                experienceRating: experienceRating,
                selectedCategory: selectedCategory
            },
            tags: [
                'atlaskit'
            ]
        }).fire($67831e29f8762387$var$ANALYTICS_CHANNEL);
        onSubmit();
    }, [
        onSubmit,
        variant,
        experienceRating,
        selectedCategory,
        createAnalyticsEvent
    ]);
    const customFields = {
        'Feedback Variant': variant,
        'Selected Category': selectedCategory ?? '',
        'Experience Rating': experienceRating ?? '',
        'Experience Rating Number': experienceRating !== undefined ? (0, $6tcD9.ExperienceRatingToNumber)[experienceRating] : '',
        ...additionalFields
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $biiXa.default), {
        onClose: onCloseWithAnalytics,
        onSubmit: onSubmitWithAnalytics,
        atlassianAccountId: aaid,
        name: name,
        email: email,
        entrypointId: $67831e29f8762387$var$ENTRYPOINT_ID,
        feedbackTitle: formatMessage(feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage((0, $l3BrO.messages).summaryTitle),
        customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6tcD9.EmojiRatingSelector), {
                    rating: experienceRating,
                    setRating: setExperienceRating,
                    label: formatMessage(rateExperience)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8qaEU.CategoryPillGroup), {
                    categories: categories,
                    selectedCategory: selectedCategory,
                    setSelectedCategory: setSelectedCategory,
                    label: formatMessage((0, $l3BrO.messages).categoryTitle)
                })
            ]
        }),
        disableSubmitButton: experienceRating === undefined,
        additionalFields: $67831e29f8762387$var$constructFeedbackContext(customFields, aaid)
    });
}
module.exports["SmartCreateFeedback"] = $67831e29f8762387$export$35c06614b8d216da;

});

parcelRegister("1uunn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $8gGM0 = parcelRequire("8gGM0");

const $90ef72367fab294b$var$fetchProfileData = (0, $2XqLN.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $42omo.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $42omo.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $42omo.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $42omo.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $90ef72367fab294b$export$68afc71177137005;

});

parcelRegister("8gGM0", function(module, exports) {

var $aYN6Z = parcelRequire("aYN6Z");

const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $aYN6Z.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $2f3ab166c93f3263$export$3e32638432616b6;

});

parcelRegister("aYN6Z", function(module, exports) {
// Copied code from conversation-assistant-instrumentation/src/common/utils/fetch.ts

var $hdasn = parcelRequire("hdasn");


var $kks0w = parcelRequire("kks0w");

/**
 * This is the copied version from `conversation-assistant-instrumentation/src/common/utils/fetch.ts`
 * @todo remove duplicate
 */ class $17e0e2057f17f262$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $17e0e2057f17f262$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $17e0e2057f17f262$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new (0, $kks0w.FetchError)(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError'
        });
    }
};
/**
 * This is the copied version from `conversation-assistant-instrumentation/src/common/utils/fetch.ts`
 * @todo remove duplicate
 */ const $17e0e2057f17f262$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $17e0e2057f17f262$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: (0, $hdasn.getTraceIdFromResponse)(response)
    });
};
module.exports["performHttpFetch"] = $17e0e2057f17f262$export$a38d93aa782475f6;

});

parcelRegister("8qaEU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fb3kw = parcelRequire("fb3kw");


var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

// This file is based on confluence/next/packages/object-sidebar-components/src/sidebar-buttons/FeedbackCollectorButton.tsx
const $0f6c1ac81be85b26$var$styles = {
    categoryPillGroupContainer: "_zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _1n261g80 _otyrpxbi",
    categoryPill: "_11c82smr _2rko1rr0 _1h6d1j28 _189ee4h9 _1dqonqa1 _4t3izwfg _1bah1h6o _4cvr1h6o _uiztglyw _o5721q9c _vchhusvi _syazi7uo _bfhki8nm _ca0q12x7 _n3td12x7 _u5f3utpp _19bvutpp _irr3plhp",
    categoryPillSelected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl"
};
const $0f6c1ac81be85b26$export$7dad6a6503835f40 = ({ categories: categories, selectedCategory: selectedCategory, setSelectedCategory: setSelectedCategory, label: label })=>{
    const onCategoryButtonClick = (0, $42omo.useCallback)((category)=>(e)=>{
            e.preventDefault();
            setSelectedCategory(category);
        }, [
        setSelectedCategory
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        label: label,
        isRequired: false,
        name: "category-group",
        id: "category-group",
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    "data-name": fieldProps.id,
                    xcss: $0f6c1ac81be85b26$var$styles.categoryPillGroupContainer,
                    role: "radiogroup",
                    children: categories.map((category)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            role: "radio",
                            "aria-checked": category.id === selectedCategory,
                            "data-name": category.text,
                            "data-value": category.id,
                            onClick: onCategoryButtonClick(category.id),
                            xcss: (0, $1Whri.cx)($0f6c1ac81be85b26$var$styles.categoryPill, category.id === selectedCategory && $0f6c1ac81be85b26$var$styles.categoryPillSelected),
                            children: category.text
                        }, category.id))
                })
            })
    });
};
module.exports["CategoryPillGroup"] = $0f6c1ac81be85b26$export$7dad6a6503835f40;

});

parcelRegister("6tcD9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");


var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $f6b57 = parcelRequire("f6b57");

const $f453c89bfd60042f$var$styles = {
    emojiSelectionContainer: "_zulpu2gc _1e0c1txw _2lx2vrvc _1bah1y6m _otyrpxbi",
    emojiButton: "_11c81c04 _2rko12b0 _1h6d1j28 _189ee4h9 _1dqonqa1 _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _irr3plhp",
    emojiButtonSelected: "_1h6d1v1w _bfhk15s3 _irr3ufnl"
};
var $f453c89bfd60042f$export$d51aadc3a803b62 = /*#__PURE__*/ function(ExperienceRating) {
    ExperienceRating["VeryDissatisfied"] = "Very dissatisfied";
    ExperienceRating["Dissatisfied"] = "Dissatisfied";
    ExperienceRating["Neutral"] = "Neutral";
    ExperienceRating["Satisfied"] = "Satisfied";
    ExperienceRating["VerySatisfied"] = "Very satisfied";
    return ExperienceRating;
}({});
const $f453c89bfd60042f$export$1224208ff0eb2a38 = {
    ["Very dissatisfied"]: 1,
    ["Dissatisfied"]: 2,
    ["Neutral"]: 3,
    ["Satisfied"]: 4,
    ["Very satisfied"]: 5
};
const $f453c89bfd60042f$var$OPTION_DATA = [
    {
        emoji: "\uD83D\uDE20",
        experienceRating: "Very dissatisfied"
    },
    {
        emoji: "\u2639\uFE0F",
        experienceRating: "Dissatisfied"
    },
    {
        emoji: "\uD83D\uDE10",
        experienceRating: "Neutral"
    },
    {
        emoji: "\uD83D\uDE42",
        experienceRating: "Satisfied"
    },
    {
        emoji: "\uD83D\uDE03",
        experienceRating: "Very satisfied"
    }
];
const $f453c89bfd60042f$export$dfef634eb7f87ea8 = ({ rating: rating, setRating: setRating, label: label })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onEmojiButtonClick = (0, $42omo.useCallback)((option, fieldProps)=>(e)=>{
            e.preventDefault();
            setRating(option.experienceRating);
            fieldProps.onChange(option.experienceRating);
        }, [
        setRating
    ]);
    const validateRating = (value)=>{
        if (!value) return formatMessage((0, $f6b57.messages).validationErrorRatingRequired);
        return undefined;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        label: label,
        isRequired: true,
        name: "rate-experience",
        id: "rate-experience",
        validate: validateRating,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        "data-name": fieldProps.id,
                        xcss: $f453c89bfd60042f$var$styles.emojiSelectionContainer,
                        role: "radiogroup",
                        children: $f453c89bfd60042f$var$OPTION_DATA.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                role: "radio",
                                "aria-checked": rating === option.experienceRating,
                                "data-name": option.experienceRating,
                                "data-value": option.experienceRating,
                                testId: `emoji-rating-${$f453c89bfd60042f$export$1224208ff0eb2a38[option.experienceRating]}`,
                                onClick: onEmojiButtonClick(option, fieldProps),
                                xcss: (0, $1Whri.cx)($f453c89bfd60042f$var$styles.emojiButton, rating === option.experienceRating && $f453c89bfd60042f$var$styles.emojiButtonSelected),
                                children: option.emoji
                            }, option.experienceRating))
                    }),
                    error && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: error
                    })
                ]
            })
    });
};
module.exports["ExperienceRatingToNumber"] = $f453c89bfd60042f$export$1224208ff0eb2a38;
module.exports["EmojiRatingSelector"] = $f453c89bfd60042f$export$dfef634eb7f87ea8;

});

parcelRegister("f6b57", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $53dbda8659203e20$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    validationErrorRatingRequired: {
        id: "smart-create-feedback.emoji-rating-selector.validation.rating.required",
        defaultMessage: "Please select a rating before submitting"
    }
});
module.exports["messages"] = $53dbda8659203e20$export$defe85febe8b728c;

});

parcelRegister("l3BrO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $78ec0b23f6329732$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "smart-create-feedback.feedback-title",
        defaultMessage: "Help us improve Create with Rovo"
    },
    rateExperience: {
        id: "smart-create-feedback.emoji-rating-selector.label",
        defaultMessage: "Please rate your experience with Create with Rovo:"
    },
    feedbackTitleNoCreate: {
        id: "smart-create-feedback.feedback-title-no-create",
        defaultMessage: "Help us improve Rovo"
    },
    rateExperienceNoCreate: {
        id: "smart-create-feedback.emoji-rating-selector.label-no-create",
        defaultMessage: "Please rate your experience with Rovo:"
    },
    summaryTitle: {
        id: "smart-create-feedback.summary-title",
        defaultMessage: "Tell us more about your experience:"
    },
    categoryTitle: {
        id: "smart-create-feedback.category-title",
        defaultMessage: "What category best describes your feedback? (optional)"
    },
    categoryPerformance: {
        id: "smart-create-feedback.category.performance",
        defaultMessage: "Performance"
    },
    categoryResponseQuality: {
        id: "smart-create-feedback.category.response-quality",
        defaultMessage: "Response quality"
    },
    categoryUserExperience: {
        id: "smart-create-feedback.category.user-experience",
        defaultMessage: "User experience"
    },
    categoryOther: {
        id: "smart-create-feedback.category.other",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $78ec0b23f6329732$export$defe85febe8b728c;

});

parcelRegister("5z48q", function(module, exports) {
var $b7edf7df99d5989b$export$cc1cd6888a5f186c = /*#__PURE__*/ function(SmartCreateFeedbackVariant) {
    SmartCreateFeedbackVariant["ROVO"] = "rovo";
    SmartCreateFeedbackVariant["CREATE_WITH_ROVO"] = "create-with-rovo";
    return SmartCreateFeedbackVariant;
}({});
module.exports["SmartCreateFeedbackVariant"] = $b7edf7df99d5989b$export$cc1cd6888a5f186c;

});


//# sourceMappingURL=SmartCreateFeedbackBanner.5fbe6ea4.js.map
